module.exports = __webpack_public_path__ + "static/media/STHiFi7.18d2a6c4.png";